import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { CourtBookingSaveInputModel } from '../models/court-booking-save-input.model';

@Injectable({
    providedIn: 'root'
})
export class CourtBookingSaveFormService {
    constructor(private formBuilder: UntypedFormBuilder) {}

    public initForm(courtBookingInput: CourtBookingSaveInputModel): UntypedFormGroup {
        return this.formBuilder.group({
            clubId: [courtBookingInput.clubId, [Validators.required]],
            date: [courtBookingInput.date, [Validators.required]],
            courtId: [courtBookingInput.courtId, [Validators.required]],
            timeFromInMinutes: [null, [Validators.required]],
            timeToInMinutes: [null],
            categoryOptionsId: [null, [Validators.required]],
            firstPlayer: [null, [Validators.required]],
            timeSlot: [null, [Validators.required]],
            secondPlayer: [null],
            thirdPlayer: [null],
            fourthPlayer: [null]
        });
    }
}


